module.exports = __webpack_public_path__ + "static/media/cross-circle.4f91f9fa.svg";